const ConversationRoutes = {
  createConversation: 'gpt/conversation/create',
  getMessages: 'gpt/conversation/message',
  sendMessage: 'gpt/conversation/message',
  getConversationList: 'gpt/conversation/list',
};

export default ConversationRoutes